import React from "react"
import { Link } from "react-router-dom"
import MetisMenu from "@metismenu/react"
// import "metismenujs/dist/metismenujs.css";

const HomeMenu = [
  { name: "Soluciones IT", routerPath: "/" },
  { name: "Desarrollo de Software", routerPath: "/software-development" },
  { name: "Ciberseguridad", routerPath: "/cyber-security" },
];

const Miscellaneous = [
  { name: "Nosotros", routerPath: "/about" },
  { name: "Servicios", routerPath: "/services" },
  { name: "Detalle de Servicios", routerPath: "/services-details" },
  { name: "Equipo", routerPath: "/team" },
  { name: "Detalle del Equipo", routerPath: "/team-details" },
  { name: "Precios", routerPath: "/price" },
  { name: "Preguntas Frecuentes", routerPath: "/faq" },
  { name: "Error-404", routerPath: "/error" },
  { name: "Iniciar Sesión", routerPath: "/login" },
  { name: "Registrarse", routerPath: "/signup" },
  { name: "Próximamente", routerPath: "/coming-soon" },
];

const ProjectMenu = [
  { name: "Proyectos Cuadrícula", routerPath: "/project-grid" },
  { name: "Proyectos Mosaico", routerPath: "/project-masonry" },
  { name: "Detalle del Proyecto", routerPath: "/project-details" },
];

const BlogMenu = [
  { name: "Blog Cuadrícula", routerPath: "/blog-grid" },
  { name: "Blog Mosaico", routerPath: "/blog-masonry" },
  { name: "Blog Clásico", routerPath: "/blog-classic" },
  { name: "Detalle de Blog V1", routerPath: "/blog-details-v1" },
  { name: "Detalle de Blog V2", routerPath: "/blog-details-v2" },
];

const MobileMenu = (props) => {
  const { onClick, active } = props;

  return (
    <div className={`mobile-menu-wrapper ${active} d-lg-none`}>
      <div className="mobile-logo mb-5">
        <Link to="/" style={{fontSize: '28px', fontWeight: 'bold', textDecoration: 'none', color: 'white', letterSpacing: '1px'}}>Cuy<span style={{color: '#E8913A'}}>Soft</span></Link>
      </div>

      <button type="button" className="close-menu" onClick={onClick}>
        <i className="bi bi-x-lg"></i>
      </button>

      <div className="side-mobile-menu">
        <MetisMenu>
          <li className="has-dropdown">
            <button type="button">Inicio</button>
            <ul className="sub-menu">
              {HomeMenu.map((val, i) => (
                <li key={i}>
                  <Link onClick={onClick} to={val.routerPath}>{val.name}</Link>
                </li>
              ))}
            </ul>
          </li>

          <li className="has-dropdown">
            <button type="button">Páginas</button>
            <ul className="sub-menu">
              {Miscellaneous.map((val, i) => (
                <li onClick={onClick} key={i}>
                  <Link to={val.routerPath}>{val.name}</Link>
                </li>
              ))}
            </ul>
          </li>

          <li className="has-dropdown">
            <button type="button">Proyectos</button>
            <ul className="sub-menu">
              {ProjectMenu.map((val, i) => (
                <li onClick={onClick} key={i}>
                  <Link to={val.routerPath}>{val.name}</Link>
                </li>
              ))}
            </ul>
          </li>

          <li className="has-dropdown">
            <button type="button">Blog</button>
            <ul className="sub-menu">
              {BlogMenu.map((val, i) => (
                <li onClick={onClick} key={i}>
                  <Link to={val.routerPath}>{val.name}</Link>
                </li>
              ))}
            </ul>
          </li>

          <li onClick={onClick}>
            <Link to="/contact">Contáctanos</Link>
          </li>
        </MetisMenu>
      </div>

      <div className="login-btn text-center mt-4">
        <Link className="theme_btn w-100" to="/login">Iniciar Sesión</Link>
        <p className="text-white">
          ¿No tienes una cuenta? <Link to="/signup" className="border-bottom">Registrarse</Link> hoy
        </p>
      </div>
    </div>
  )
}

export default MobileMenu
